import Matter from 'matter-js'
import MatterRope from './MatterRope'
import MatterCup from './MatterCup'
import MatterTapi from './MatterTapi'
import MatterStraw from './MatterStraw'

const Engine = Matter.Engine,
  Render = Matter.Render as any,
  Runner = Matter.Runner,
  Bodies = Matter.Bodies,
  Constraint = Matter.Constraint,
  World = Matter.World,
  Composites = Matter.Composites,
  Composite = Matter.Composite,
  Body = Matter.Body,
  Mouse = Matter.Mouse

export default class MatterEngine {
  private engine: Matter.Engine
  private world: Matter.World

  constructor(selector: string) {
    const WORLD_WIDTH = 800
    const WORLD_HEIGHT = 500
    const engine = this.engine = Engine.create()
    const world = this.world = engine.world
    world.gravity.y = 0.7
    engine.timing.timeScale = 0.2
    const render = Render.create({
      element: document.querySelector(selector),
      engine: engine,
      options: {
        width: WORLD_WIDTH * 1,
        height: WORLD_HEIGHT * 1,
        showAngleIndicator: true,
        showCollisions: true,
        showVelocity: true
      } as Matter.IRendererOptions
    })
    Render.lookAt(render, {
      min: { x: WORLD_WIDTH * 0, y: WORLD_HEIGHT * 0 },
      max: { x: WORLD_WIDTH * 1, y: WORLD_HEIGHT * 1.2 }
    })
    Render.run(render)

    const runner = Runner.create({})
    Runner.run(runner, engine)
    
    const floor = Bodies.rectangle(400, 550, 800, 50, { 
      isStatic: true,
      restitution: 0,
      friction: 1,
      density: 1000 })
    World.add(world, floor)

    const wallPos = {
      tl: {x: 0, y: -WORLD_HEIGHT * 2},
      tr: {x: WORLD_WIDTH, y: -WORLD_HEIGHT * 2},
      bl: {x: 0, y: WORLD_HEIGHT * 2},
      br: {x: WORLD_WIDTH, y: -WORLD_HEIGHT * 2},
      w: WORLD_WIDTH,
      h: WORLD_HEIGHT * 4
    }
    const wall = Body.create({
      parts: [
        /* T */ Bodies.rectangle(wallPos.tl.x + wallPos.w / 2, wallPos.tl.y, wallPos.w, 100),
        /* B */ Bodies.rectangle(wallPos.tl.x + wallPos.w / 2, wallPos.bl.y, wallPos.w, 100),
        /* L */ Bodies.rectangle(wallPos.tl.x, wallPos.tl.y + wallPos.h / 2, 100, wallPos.h),
        /* R */ Bodies.rectangle(wallPos.tr.x, wallPos.tr.y + wallPos.h / 2, 100, wallPos.h),
      ],
      isStatic: true,
      density: 1000
    })
    World.add(world, wall)

    // mouse control

    const mouse = Mouse.create(render.canvas)
    const mouseConstraint = Matter.MouseConstraint.create(engine, {
      mouse: mouse,
      constraint: {
        stiffness: 0.9,
        render: {
          visible: true,
          lineWidth: 1,
          strokeStyle: 'red'
        }
      } as any
    }) 
    World.add(world, mouseConstraint);
    // keep the mouse in sync with rendering
    render.mouse = mouse;
  }

  public addRope(ed1: Matter.Body, ed2: Matter.Body, onupdated?: (points: Matter.Vector[]) => void): MatterRope {
    const rope = new MatterRope(this.world, ed1, ed2)
    // event handling
    Matter.Events.on(this.engine, 'afterUpdate', (ev) => {
      if (onupdated) { onupdated(rope.points) }
    })
    return rope
  }

  public addCup(onupdated?: (points: Matter.Vector[], outer: {lt: Matter.Vector, rt: Matter.Vector, lb: Matter.Vector, rb: Matter.Vector}) => void): MatterCup {
    const cup = new MatterCup(this.world)
    Matter.Events.on(this.engine, 'afterUpdate', (ev) => {
      if (onupdated) { 
        const outer = {
          lt: cup.topLeft,
          rt: cup.topRight,
          lb: cup.bottomLeft,
          rb: cup.bottomRight
        }
        onupdated(cup.points, outer)
      }
    })
    return cup
  }

  public addStraw(onupdated?: (x: number, y: number, w: number, h: number, r: number) => void): MatterStraw {
    const straw = new MatterStraw(this.world, 280, 400, 40, 480)
    // event handling
    Matter.Events.on(this.engine, 'afterUpdate', (ev) => {
      if (onupdated) { onupdated(straw.x, straw.y, straw.w, straw.h, straw.rotation) }
    })
    return straw
  }

  public addTapi(onupdated?: (points: Matter.Vector[]) => void): MatterTapi {
    const water = new MatterTapi(this.world)
    // event handling
    Matter.Events.on(this.engine, 'afterUpdate', (ev) => {
      if (onupdated) { onupdated(water.points) }
    })
    return water
  }

}
